<template>
  <div class="cancellation-container">
    <div class="cancellation-card">
      <h2 class="title">Está pensando em sair?</h2>

      <p class="message">
        Antes de confirmar, queremos entender se tem algo que não saiu como você esperava. Estamos aqui para ouvir e, se
        possível, ajustar.
      </p>
      <p class="message">
        Nosso app foi feito pra te ajudar a ter mais clareza, controle e organização financeira — no seu ritmo, do seu
        jeito.
      </p>

      <div class="features">
        <p class="feature-title">👀 Você já usou estes recursos?</p>
        <ul>
          <li class="feature"><span class="check">✅</span> Diagnóstico financeiro gratuito</li>
          <li class="feature"><span class="check">✅</span> Painel para acompanhar metas</li>
          <li class="feature"><span class="check">✅</span> Relatórios simples dos seus gastos</li>
        </ul>
      </div>

      <p class="help-message">
        Se algo não fez sentido ou ficou confuso, estamos aqui para te ouvir.<br>
        Fale com a gente antes de decidir.
      </p>

      <div class="action-buttons">
        <button class="btn btn-outline-secondary" @click="$emit('continue-cancellation')">
          Quero cancelar
        </button>
         <button class="btn btn-primary" @click="$emit('contact-support')">
          Conversar com a gente
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CancellationRetention'
}
</script>

<style scoped>
.cancellation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.cancellation-card {
  padding: 30px;
  max-width: 600px;
  width: 100%;
}

.title {
  color: #fff;
  font-size: 28px;
  margin-bottom: 20px;
  text-align: center;
}

.message {
  color: #e4e4e4;
  font-size: 16px;
  margin-bottom: 15px;
  line-height: 1.5;
}

.features {
  background-color: #1e2433;
  padding: 20px;
  border-radius: 8px;
  margin: 20px 0;
}

.feature-title {
  color: #fff;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 500;
}

.feature {
  color: #e4e4e4;
  font-size: 16px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.check {
  color: #4caf50;
  margin-right: 10px;
}

.help-message {
  color: #e4e4e4;
  font-size: 16px;
  margin: 20px 0;
  text-align: center;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 30px;
}

.btn {
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: #cb5540;
  color: white;
  border: none;
}

.btn-primary:hover {
  background-color: #a8473a;
}

.btn-outline-secondary {
  background-color: transparent;
  color: #e4e4e4;
  border: 1px solid #e4e4e4;
}

.btn-outline-secondary:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>
